import { useGetUsersQuery } from '~/api/v2/hooks';

const useFullName = () => {
  const { data: users, isFetching } = useGetUsersQuery({});

  const fullName = (userId?: string | null) => {
    const user = users?.find((user) => user.id === userId);

    return user ? `${user.first_name} ${user.last_name}` : userId;
  };

  return { fullName, isFetching };
};

export default useFullName;
